/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import { StickyContainer, Sticky } from 'react-sticky';
import { Link } from "gatsby"
import image from '../images/main_logo.jpg';
import menuIcon from '../images/menu_icon.jpg'
import window from 'global';
import "./layout.css"
import Helmet from 'react-helmet'
import icon32 from '../images/favicon_creare.jpg'
import { navigate } from '@reach/router';
import Img from "gatsby-image";


class Layout extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      menuOpen: false,
    }
  }
  render ()  {
    return (
          
          <StickyContainer>
          <Helmet
            link={[
                { rel: 'shortcut icon', type: 'image/png', href: `${icon32}` }
            ]}
          >
          <script type="text/javascript">
{`var _iub = _iub || [];
_iub.csConfiguration = {"gdprAppliesGlobally":false,"lang":"it","siteId":1559337,"cookiePolicyUrl":"https://www.iubenda.com/privacy-policy/36901609","consentOnScroll":false,"cookiePolicyId":36901609, "banner":{ "position":"bottom","textColor":"white","backgroundColor":"black" } };
`}</script><script type="text/javascript" src="//cdn.iubenda.com/cs/iubenda_cs.js" charset="UTF-8" async> </script>
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-137791217-1"></script>
<script>
  {`window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-137791217-1');`}
</script>

          </Helmet>
          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.8.1/css/all.css" integrity="sha384-50oBUHEmvpQ+1lW4y57PTFmhCaXp0ML5d60M1M7uH2+nqUivzIebhndOJK28anvf" crossorigin="anonymous" />
  
    
            <div
              className="topLogoContainer"
              style={{
                height:'200px',
                padding: '20px 0px 20px 0px'
              }}>
              <div 
                alt="logo"
                style={{
                  maxHeight: '170px',
                  height: '170px',
                  width: '170px',
                  left: '50%',
                position: 'absolute',
                transform: 'translate(-50%, 0)'
              }}
              onClick={() => {
                navigate('/');
              }}
              >
                <StaticQuery
        query={graphql`
        query {
          mainLogo3: file(relativePath: {eq: "main_logo.jpg"}) {
            childImageSharp {
                fluid{
                    ...GatsbyImageSharpFluid_noBase64
                }
            }
           }
          }
        `}
        render={data => (<Img fluid={data.mainLogo3.childImageSharp.fluid} />)} />
              </div>
            </div>
            <Sticky topOffset={200} style={{
              backgroundColor: 'white',
            }}>
            {({
                style,
     
                // the following are also available but unused
                isSticky,
                wasSticky,
                distanceFromTop,
                distanceFromBottom,
                calculatedHeight
              }) => <div className="overMenu" style={style}>
                <div
                className="menu"
                style={{
                  backgroundColor: 'white',
                  width: '100%',
                  padding: '10px 0px 10px 0px',
                }}>
                  <div className="desktopMenu">
                    <div style={{
                      textTransform: 'uppercase',
                      maxWidth: '1080px',
                      padding: '0px 1.2875rem',
                      height: '44px',
                      margin: 'auto',
                      display: 'flex',
                      justifyContent: 'space-around'
                    }}>
                      <div className={window.pageYOffset > 200 ? 'menuLogo' : 'menuLogo hidden'} style={{
                        flexGrow:1,
                      }}>
                      <Link to="/">
                      <img alt="icon" src={menuIcon} />
                      </Link>
                      </div>
                      <div style={{
                        width: '300px',
                        display: 'flex',
                        justifyContent: 'space-around',
                      }}>
                        <Link to="/" className={(() => {
                          if (typeof(window.location) === 'undefined') return '';
                          return window.location.pathname == '/' ? 'selected' : ''})()}>home</Link>
                        <Link to="/archivio" className={(() => {
                          if (typeof(window.location) === 'undefined') return '';
                          return window.location.pathname == '/archivio/' ? 'selected' : ''})()}>archivio</Link>
                        <Link to="/cerca" className={(() => {
                          if (typeof(window.location) === 'undefined') return '';
                          return window.location.pathname == '/cerca/' ? 'selected' : ''})()}>cerca</Link>
                        <Link to="/about" className={(() => {
                          if (typeof(window.location) === 'undefined') return '';
                          return window.location.pathname == '/about/' ? 'selected' : ''})()}>about</Link>
                      </div>
                      <div style={{
                        flexGrow: 1.17,
                      }}>

                      </div>
                    </div>
                  </div>
                  <div className="mobileMenu">
                    <div style={{
                        textTransform: 'uppercase',
                        maxWidth: '100vw',
                        padding: '0px 40px 0px 40px',
                        height: '44px',
                        margin: 'auto',
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}>
                        
                        <div className={window.pageYOffset > 200 ? 'menuLogo' : 'menuLogo hidden'}>
                        <Link to="/">
                        <img alt="icon" src={menuIcon} />
                          </Link>
                        </div>
                        <div
                          style={{padding: 10}}
                          onClick={() => {
                            let state = this.state;
                            this.setState({
                              menuOpen: !state.menuOpen
                            });
                          }}
                        ><i style={{fontSize: '26px'}}className="fas fa-bars"></i>
                        </div>
                      </div>
                      <div
                        className={this.state.menuOpen ? 'mobileOptions' : 'mobileOptions hidden'} 
                      >
                        <Link to="/" className={(() => {
                          if (typeof(window.location) === 'undefined') return '';
                          return window.location.pathname == '/' ? 'selected' : ''})()}
                          onClick={() => {
                            this.setState({menuOpen: false});
                          }}
                          >home</Link>
                        <Link to="/archivio" className={(() => {
                          if (typeof(window.location) === 'undefined') return '';
                          return window.location.pathname == '/archivio/' ? 'selected' : ''})()}
                          onClick={() => {
                            this.setState({menuOpen: false});
                          }}
                          >archivio</Link>
                        <Link to="/cerca" className={(() => {
                          if (typeof(window.location) === 'undefined') return '';
                          return window.location.pathname == '/cerca/' ? 'selected' : ''})()}
                          onClick={() => {
                            this.setState({menuOpen: false});
                          }}
                          >cerca</Link>
                        <Link to="/about" className={(() => {
                          if (typeof(window.location) === 'undefined') return '';
                          return window.location.pathname == '/about/' ? 'selected' : ''})()}
                          onClick={() => {
                            this.setState({menuOpen: false});
                          }}
                          >about</Link>
                      </div>
                  </div>
                  
               

                </div>
              </div>}
            </Sticky>
            <div
              style={{
                margin: `0 auto`,
                maxWidth: 1080,
                padding: `0px 1.0875rem 1.45rem`,
                paddingTop: 0,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'calc(100vh - 260px)'
              }}
            >
              <main
                style={{
                  flexGrow: '1'
                }}
              >{this.props.children}</main>
              <footer>

                <div className="footer_head">
                  <div><a href = "mailto: info@crearemondi.it">SCRIVIMI</a></div>
                  <div><Link to="/termini-e-condizioni">TERMINI E CONDIZIONI DI UTILIZZO</Link></div>
                </div>
                <div className="footer_foot">

                Copyright © {new Date().getFullYear()} - CreareMondi.it - Vietata la riproduzione.
                
                </div>
              </footer>
            </div>
          </StickyContainer>
            
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
